// src/features/policies/constants/enums.js

export const ACTION_TYPES = [
  "SCHEMA_DELETE",
  "SCHEMA_PUBLISH",
  "SCHEMA_APPROVE",

  "MASK",
  "UNMASK",
  "TOKENIZE",
  "DETOKENIZE",

  "KEY_CREATE",
  "KEY_DISABLE",
  "KEY_REVOKE",

  "POLICY_CREATE",
  "POLICY_UPDATE"
];

export const POLICY_EFFECTS = [
  "NONE",
  "ALLOW",
  "DENY",
  "MASK",
  "REDACT",
  "MASK_EMAIL",
  "MASK_PHONE",
  "LAST_4"
];

export const POLICY_STATUSES = [
  "DRAFT",
  "ACTIVE",
  "SUSPENDED",
  "ARCHIVED"
];

export const CONDITION_TYPES = [
  "ENVIRONMENT",
  "DATA_CLASSIFICATION",
  "RESOURCE_ATTRIBUTE",
  "SUBJECT_ATTRIBUTE"
];

export const CONDITION_OPERATORS = [
  "EQUALS",
  "NOT_EQUALS",
  "IN",
  "NOT_IN"
];

export const RESOURCE_TYPES = [
  "SCHEMA",
  "DATA",
  "KEY"
];

export const DATA_CLASSIFICATIONS = [
  "PUBLIC",
  "INTERNAL",
  "CONFIDENTIAL",
  "RESTRICTED"
];